
export const ROUTER_DEACTIVATE_INTERMEDIATED_VEHICLE = {
  routes: ["/", "/logs", "/vehiclesDashboard/vehicleDetails/:id?", "*"],
};

export const DINAMIC_TABS_DEACTIVATE_INTERMEDIATED_VEHICLE = {
  deactivate: true,
};

export const MAIN_TABLE_DEACTIVATE_INTERMEDIATED_VEHICLE = {
  deactivate: true,
};
